<template>
  <div class="sample-database-container">
    <div class="table-container" v-if="$store.state.appConfig.windowWidth >= 769">
      <div v-if="$store.state.ancientIndividualDatabase.sampleDetail === null">
        <div class="spinner" v-if="this.$store.state.appConfig.isLoading">
          <SpinnerContainer />
        </div>
        <div v-else>
          <table class="sample-table header">
            <thead>
              <tr>
                <th>{{$tI('Sample ID title')}}</th>
                <th>{{$tI('Date column title')}}</th>
                <th class="fix-sample-column"> {{$tI('Label title')}}</th>
                <th class="text-center">{{$tI('Y DNA column title')}}</th>
                <th class="text-center">{{$tI('mtDNA column title')}}</th>
                <th>{{$tI('Location column title')}}</th>
                <th>{{$tI('Details column title')}}</th>
              </tr>
            </thead>
          </table>
          <div class="table-wrapper cs-scroll-style">
            <table class="sample-table">
              <tbody>
                <tr v-for="item in popList" :key="item.id">
                  <td>{{ item.sampleID }}</td>
                  <td>
                    {{tData(item.date)}}
                  </td>
                  <td class="fix-sample-column">{{ $t(item.name) }}</td>
                  <td class="text-center">
                    <span v-if="item.yDNAISOGG.length > 1 && item.yDNATM.length > 1">{{item.yDNAISOGG}} ({{item.yDNATM}})</span>
                    <span v-else-if="item.yDNAISOGG.length > 1">{{item.yDNAISOGG}}</span>
                    <span v-else-if="item.yDNATM.length > 1">{{item.yDNATM}}</span>
                  </td>
                  <td class="text-center">{{ item.mtDNA }}</td>
                  <td>{{item.location}}</td>
                  <td>
                    <div class="table-action table-action-edit lab-p-8" @click="openDetail(item)" 
                      v-click-track="'Iframe.ancientDnaSampleDatabaseDetailsButtonClicked'">
                      <TableDetailIcon />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="mt-4">
          <ListPagination />
        </div>
      </div>
      
      <AncientIndividualSampleDetail v-else/>
    </div>
    
    <div class="table-container" v-else>
      <div class="encyclopedia-mobile">
        <SpinnerContainer v-if="this.$store.state.appConfig.isLoading"/>
        <template  v-else>
          <div v-for="(item, index) in popList" :key="index">
            <div class="encyclopedia-mobile-item dashboard-card">
              <div>
                <div class="mobile-item-top">
                  <div class="item-info left-info">
                    <h5>{{$tI('Label title')}}</h5>
                    <h6>{{ $t(item.name) }}</h6>
                  </div>
                  <div class="item-info right-info">
                    <h5>{{$tI('Location column title')}}</h5>
                    <h6>{{$t(item.location)}}</h6>
                  </div>
                </div>
                <div class="mobile-item-bottom">
                  <div class="item-info left-info">
                    <h5>{{$tI('Date column title')}}</h5>
                    <h6>{{tData(item.date)}}</h6>
                  </div>
                  <div class="item-info right-info">
                    <h5>{{$tI('Sample ID title')}}</h5>
                    <h6>{{item.sampleID}}</h6>
                  </div>
                </div>
              </div>
              <div class="mobile-encyclopedia-icon">
                <span class="cursor-pointer" @click="openDetailMobile(item, index)"
                  v-click-track="'Iframe.ancientDnaSampleDatabaseDetailsButtonClicked'"> 
                  <circle-plus-icon v-show="!item.isOpenDetail" className="encyclopedia"/>
                  <circle-x-icon v-show="item.isOpenDetail" className="encyclopedia"/>
                </span>
              </div>
            </div>

            <AncientIndividualSampleDetailMobile v-if="$store.state.ancientIndividualDatabase.sampleDetail && item.isOpenDetail" />
          </div>
        </template>
      </div>

      <div class="mt-4">
        <ListPagination />
      </div>
    </div>
  </div>
</template>

<script>
import { tDateParser } from '@/services/Base/utils'

import TableDetailIcon from '@/components/icons/TableDetailIcon.vue';
import CirclePlusIcon from '@/components/icons/CirclePlusIcon.vue';
import CircleXIcon from '@/components/icons/CircleXIcon.vue';

import ListPagination from '../ListPagination.vue';
import AncientIndividualSampleDetail from './AncientIndividualSampleDetail.vue';
import AncientIndividualSampleDetailMobile from './AncientIndividualSampleDetailMobile.vue';

export default {
  components: {
    TableDetailIcon,
    CirclePlusIcon,
    CircleXIcon,
    ListPagination,
    AncientIndividualSampleDetail,
    AncientIndividualSampleDetailMobile,
  },
  data() {
    return {
    }
  },
  methods: {
    openDetail(item) {
      this.$store.state.ancientIndividualDatabase.sampleDetail = item;
    },
    openDetailMobile(item, index) {
      item.isOpenDetail = !item.isOpenDetail;
      if (item.isOpenDetail) {
        this.$store.state.ancientIndividualDatabase.sampleDetail = item;
      } else {
        this.$store.state.ancientIndividualDatabase.sampleDetail = null;
      }

      this.popList.forEach((element, indexItem) => {
        if (indexItem != index) {
          element.isOpenDetail = false;
        }
      });
    },

    tData(dateText) {
      let date = dateText;

      if(date) {
        const dateObj = tDateParser(date);
        date = this.$tParams(dateObj.key, dateObj.params, dateObj.value, dateText);
      }

      return date;
    },
  },
  computed: {
    popList() {
      return this.$store.getters['ancientIndividualDatabase/getAncientDatabaseList'];
    },
  },
  watch: {
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
</style>
